<mat-drawer-container>
  <mat-drawer #drawer class="example-sidenav" mode="over" position=start>
    <button class="drawer-close-button" (click)="drawer.toggle()">
      <mat-icon inline="true" class="btn-iconOrange">arrow_back</mat-icon>
    </button>
    <app-mobileoptions></app-mobileoptions>
  

  </mat-drawer>
  <div class="example-sidenav-content">
    <div class="smallcircle"></div>
    <button class="buttontT" type="button" (click)="drawer.toggle()">
     Create Your Menu
    </button>
    <div class="line"></div>
    <img mat-card-image src="assets/images/popup.png" class="cym">
    <p class="pclass">Explore SpiceTrail's diverse collection of more than 100 food items , categorized by
      occassions and create you own menu</p>
    
  </div>

</mat-drawer-container>


